import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo-tb3.png'


const _withScopeId = n => (_pushScopeId("data-v-50685cd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-subtext" }, "EDUCATION FOR SCIENCE, TECHNOLOGY, ART", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_cmp_responsive_menu = _resolveComponent("cmp-responsive-menu")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "app-bar-container rounded" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_toolbar_title, { class: "app-bar-title" }, {
        default: _withCtx(() => [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_img, {
                width: 420,
                "aspect-ratio": "16/9",
                cover: "",
                src: _imports_0
              })
            ]),
            _: 1
          }),
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_v_spacer),
      _createVNode(_component_cmp_responsive_menu)
    ]),
    _: 1
  }))
}